import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material';
import { TreatmentResonsComponent } from './treatment-resons.component';



@NgModule({
  declarations: [TreatmentResonsComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule
  ],
  exports:[TreatmentResonsComponent]
})
export class TreatmentResonsModule { }
